// ── AR Flow — NOVA INTERFACE: 🏆 Pontos do mês (Meu Dia) ─────────────────────
// Consultor: o ranking da loja (só o total dos colegas), o detalhe dos pontos
// dele e as dicas da coach. Gerente e administração: o detalhe de todos e a
// "prévia" (conta desde o dia 1º, antes da estreia oficial).
// Só leitura: busca /api/pontos. Não grava nada.

import { useEffect, useState } from "react";
import NovemberPointsPreview from "./NovemberPointsPreview";

const MONO = "'IBM Plex Mono', ui-monospace, monospace";
const DISPLAY = "'Bricolage Grotesque', 'Source Sans 3', system-ui, sans-serif";
const dm = v => (v ? v.slice(0, 10).split("-").reverse().slice(0, 2).join("/") : "");
const sinal = n => (n > 0 ? `+${n}` : String(n));

export async function lerJsonPontos(r) {
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.error || "Não foi possível carregar.");
  return d;
}

function Detalhe({ th, pessoa, tabela }) {
  const rot = Object.fromEntries((tabela || []).map(t => [t.id, t.rotulo]));
  const linhas = Object.entries(pessoa?.regras || {}).sort((a, b) => b[1].pontos - a[1].pontos);
  if (!linhas.length) return <div style={{ fontSize: 13, color: th.muted, padding: "4px 0 8px" }}>Ainda sem pontos no período.</div>;
  return (
    <div style={{ padding: "2px 0 8px" }}>
      {linhas.map(([id, r]) => (
        <div key={id} style={{ display: "flex", justifyContent: "space-between", gap: 10, fontSize: 13, padding: "3px 0" }}>
          <span style={{ color: th.text }}>{rot[id] || id}{r.qtd > 1 ? ` · ${r.qtd}×` : ""}</span>
          <span style={{ fontFamily: MONO, color: r.pontos < 0 ? "#B42318" : th.text }}>{sinal(r.pontos)}</span>
        </div>
      ))}
    </div>
  );
}

export default function PontosCard({ theme, currentUser }) {
  const th = theme;
  const line = th.nuLine || th.sandDark;
  const gestor = currentUser?.role && currentUser.role !== "consultant";
  const [previa, setPrevia] = useState(Boolean(gestor));
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState("");
  const [aberto, setAberto] = useState(null);
  const [verTabela, setVerTabela] = useState(false);
  // Fica no topo do Meu Dia, fechado numa linha (posição e pontos). Abre com um toque.
  const [expandido, setExpandido] = useState(false);

  useEffect(() => {
    let vivo = true;
    setErro("");
    fetch(`/api/pontos${previa ? "?previa=1" : ""}`, { credentials: "include" })
      .then(lerJsonPontos)
      .then(d => { if (vivo) setDados(d); })
      .catch(e => { if (vivo) setErro(e.message); });
    return () => { vivo = false; };
  }, [previa]);

  const tabela = dados?.tabela || [];
  const lojaEu = (dados?.lojas || []).find(l => l.ranking.some(p => p.id === currentUser?.id)) || (dados?.lojas || [])[0];
  const euRk = lojaEu?.ranking.find(p => p.id === currentUser?.id);
  const lider = lojaEu?.ranking[0];
  const resumo = !dados ? (erro ? "Não foi possível carregar." : "Calculando…")
    : dados.naoIniciado ? `Começa em ${dm(dados.inicio)}`
    : euRk ? `Você está em ${euRk.posicao}º · ${euRk.total} pts${lider && lider.id !== euRk.id ? ` · ${lider.nome} lidera com ${lider.total}` : euRk.total > 0 ? " · você lidera 👑" : ""}`
    : lider ? `${lider.nome} lidera com ${lider.total} pts` : "";
  return (
    <section style={{ background: "#fff", border: `1px solid ${line}`, borderTop: "3px solid #7A5AF8", borderRadius: 4, marginBottom: 16, maxWidth: 880 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 10, padding: "12px 16px", borderBottom: expandido ? `1px solid ${line}` : "none", flexWrap: "wrap" }}>
        <button type="button" onClick={() => setExpandido(v => !v)} aria-expanded={expandido}
          style={{ display: "flex", alignItems: "baseline", gap: 10, flexWrap: "wrap", background: "none", border: "none", padding: 0, cursor: "pointer", fontFamily: "inherit", color: th.text, textAlign: "left" }}>
          <span style={{ fontFamily: DISPLAY, fontSize: 17, fontWeight: 700 }}>🏆 Pontos do mês</span>
          <span style={{ fontFamily: MONO, fontSize: 13, color: "#5B21B6" }}>{resumo}</span>
          <span aria-hidden="true" style={{ fontSize: 12, color: th.muted }}>{expandido ? "▲" : "▼ ver ranking"}</span>
        </button>
        {expandido && <div style={{ display: "flex", gap: 12, alignItems: "baseline" }}>
          {gestor && (
            <label style={{ fontSize: 12, color: th.muted, display: "flex", gap: 5, alignItems: "center" }}>
              <input type="checkbox" checked={previa} onChange={e => setPrevia(e.target.checked)} /> Prévia (desde o dia 1º)
            </label>
          )}
          <button type="button" onClick={() => setVerTabela(v => !v)} style={{ background: "none", border: "none", color: th.accent, fontSize: 13, fontWeight: 700, cursor: "pointer", textDecoration: "underline", fontFamily: "inherit" }}>
            {verTabela ? "Esconder a tabela" : "Como ganhar pontos"}
          </button>
        </div>}
      </div>
      {expandido && <div style={{ padding: "8px 16px 12px" }}>
        {verTabela && (
          <div style={{ background: th.sandDark, borderRadius: 4, padding: "8px 12px", marginBottom: 10 }}>
            {tabela.filter(t => t.id !== "venda_valor").map(t => (
              <div key={t.id} style={{ display: "flex", justifyContent: "space-between", gap: 10, fontSize: 13, padding: "2px 0" }}>
                <span>{t.rotulo}{t.id === "venda" ? " (+1 a cada R$ 1.000, até +20)" : ""}</span>
                <span style={{ fontFamily: MONO, color: t.pontos < 0 ? "#B42318" : th.text }}>{sinal(t.pontos)}</span>
              </div>
            ))}
          </div>
        )}
        {erro && <div role="alert" style={{ fontSize: 13, color: "#991B1B" }}>{erro}</div>}
        {!dados && !erro && <div style={{ fontSize: 13, color: th.muted }}>Calculando os pontos…</div>}
        {dados?.naoIniciado && <div style={{ fontSize: 14, color: th.text }}>Os pontos começam a contar em <strong>{dm(dados.inicio)}</strong>. Veja em "Como ganhar pontos" o que vale.</div>}
        {dados && !dados.naoIniciado && (
          <>
            <div style={{ fontSize: 12, color: th.muted, marginBottom: 6 }}>
              De {dm(dados.periodo?.de)} a {dm(dados.periodo?.ate)}{dados.previa ? " · prévia, ainda não oficial" : ""}
            </div>
            {dados.eu?.dicas?.length > 0 && (
              <div style={{ background: "#F5F3FF", borderRadius: 4, padding: "8px 12px", marginBottom: 10 }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: "#5B21B6", marginBottom: 2 }}>🧠 Dica da coach</div>
                {dados.eu.dicas.map(d => <div key={d} style={{ fontSize: 13, color: th.text }}>{d}</div>)}
              </div>
            )}
            {(dados.lojas || []).map(loja => (
              <div key={loja.storeId} style={{ marginBottom: 8 }}>
                {dados.lojas.length > 1 && <div style={{ fontSize: 13, fontWeight: 700, color: th.muted, margin: "6px 0 2px" }}>{loja.nome}</div>}
                {loja.ranking.map(p => {
                  const souEu = p.id === currentUser?.id;
                  const podeAbrir = Boolean(p.regras);
                  return (
                    <div key={p.id} style={{ borderBottom: `1px solid ${line}` }}>
                      <button type="button" disabled={!podeAbrir} onClick={() => setAberto(a => (a === p.id ? null : p.id))}
                        style={{ width: "100%", display: "flex", alignItems: "center", gap: 10, background: souEu ? "#FFFBEB" : "none", border: "none", padding: "8px 4px", cursor: podeAbrir ? "pointer" : "default", fontFamily: "inherit", color: th.text, textAlign: "left" }}>
                        <span style={{ fontFamily: MONO, width: 26, color: th.muted }}>{p.posicao}º</span>
                        <span style={{ flex: 1, fontWeight: souEu ? 700 : 500, fontSize: 14 }}>{p.nome}{souEu ? " (você)" : ""}{p.posicao === 1 && p.total > 0 ? " 👑" : ""}</span>
                        <span style={{ fontFamily: MONO, fontSize: 15, fontWeight: 700 }}>{p.total}</span>
                      </button>
                      {aberto === p.id && podeAbrir && <div style={{ padding: "0 4px 0 40px" }}><Detalhe th={th} pessoa={p} tabela={tabela} /></div>}
                    </div>
                  );
                })}
              </div>
            ))}
          </>
        )}
        <NovemberPointsPreview
          theme={th}
          currentUser={currentUser}
        />
      </div>}
    </section>
  );
}
